import React from 'react';
import { useResponsiveInViewConfigMargin } from '../../../hooks';
import { Container, Section, Switcher } from '../../common';

const AlternatingRows = ({ page, sanity, section }) => {
  const { colors } = sanity;
  const inViewConfigMargin = useResponsiveInViewConfigMargin();

  return (
    <Section
      idName="company-overview"
      padding="sm"
      bgColor={colors?.neutral?.white}
      h2Color={colors?.neutral?.darker}
    >
      <Container
        padding="none"
        classes="max-w-md px-4 lg:px-0 text-center sm:max-w-3xl lg:max-w-7xl"
        inViewConfigMargin={inViewConfigMargin}
      >
        <Switcher page={page} sanity={sanity} section={section} />
      </Container>
    </Section>
  );
};

AlternatingRows.displayName = 'AlternatingRows';

export { AlternatingRows };
